<template>
  <div class="module-part">
    <el-form
      v-for="(item, i) in form.sliders"
      :key="i"
      size="small"
      ref="form"
      :model="item"
      label-width="110px"
    >
      <div class="slider-item__header">
        <p class="slider-item__title">
          {{ "滑动条" + (i + 1) }}
        </p>
        <div class="slider-item__operation">
          <el-button
            :disabled="i == 0"
            size="mini"
            plain
            type="primary"
            @click="move(i, 'up')"
            >上移</el-button
          >
          <el-button
            :disabled="i == form.sliders.length - 1"
            size="mini"
            plain
            type="primary"
            @click="move(i, 'down')"
            >下移</el-button
          >
          <el-button size="mini" plain type="danger" @click="deleteItem(i)"
            >删除</el-button
          >
        </div>
      </div>
      <el-form-item prop="activeImage" class="basic-form-item">
        <el-upload
          :ref="'upload' + i"
          :show-file-list="false"
          action="#"
          class="uploadicon"
          accept=".png"
          :limit="1"
          :http-request="(file) => uploadFile(file, i)"
        >
          <i class="el-icon-plus icon-container" v-if="!item.activeImage"></i>
          <img
            :src="createImage(item.activeImage)"
            v-else
            class="img-container"
          />
        </el-upload>
        <el-input size="small" placeholder="滑动条名称" v-model="item.name" />
        <el-input
          size="small"
          placeholder="功能描述"
          v-model="item.description"
        />
      </el-form-item>
      <el-form-item label="提示语" prop="hint">
        <el-input
          style="width: 350px"
          v-model="item.hint"
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="初始值"
        prop="defaultValue"
        class="initvalue-form-item"
      >
        <el-input-number
          style="width: 200px"
          v-model="item.defaultValue"
          :max="item.bounds.max"
          :min="item.bounds.min"
        ></el-input-number>
        <!-- <span class="marginL10">秒</span> -->
        <el-link
          type="primary"
          class="marginL20"
          @click="handleScopeTime(item, i)"
          >取值范围</el-link
        >
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-input style="width: 350px" v-model="item.unit"></el-input>
      </el-form-item>
      <el-form-item
        label="属性"
        prop="propertyId"
        :rules="[{ required: true, message: '请选择属性', trigger: 'change' }]"
      >
        <el-select v-model="item.propertyId" size="small">
          <el-option
            v-for="type in propertes"
            :key="type.id"
            :value="type.id"
            :label="type.propertyName"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" plain type="primary" @click="addItem"
        >+ 滑动条</el-button
      >
    </div>
    <div>
      <el-button size="small" @click="addContent" type="danger" plain
        >说明内容配置</el-button
      >
    </div>
    <TimeRanger
      :row="ranger"
      @set="setTime"
      v-if="visible"
      :visible.sync="visible"
    />
    <ContentEdit
      @set="setContent"
      :propertes="propertes"
      v-if="contentVisible"
      :visible.sync="contentVisible"
      :content="content"
    />
  </div>
</template>

<script>
import TimeRanger from "./TimeRanger";
import ContentEdit from "./ContentEdit";
export default {
  props: ["propertes", "pages", "row"],
  components: {
    TimeRanger,
    ContentEdit,
  },
  data() {
    return {
      form: {
        sliders: [
          {
            activeImage: "",
            name: "",
            description: "",
            hint: "",
            unit: "",
            defaultValue: undefined,
            bounds: {},
            propertyId: "",
          },
        ],
        floatContents: [],
      },
      visible: false,
      contentVisible: false,
      ranger: {},
      content: {},
      currIndex: 0,
    };
  },
  created() {
    if (this.row.id) {
      const sliders = [];
      if (this.row.slideWindow.sliderList) {
        this.row.slideWindow.sliderList.forEach((item) => {
          sliders.push({
            ...item,
            bounds: JSON.parse(item.bounds),
          });
        });
      }
      this.form = {
        ...this.form,
        sliders,
        floatContents: this.row.floatContents,
      };
    }
  },
  methods: {
    createImage(fileName) {
      return fileName ? this.$store.state.standard.fileLoad + fileName : "";
    },
    async upload(file) {
      const formData = new FormData();
      formData.append("files", file.file);
      let res = await this.$http.uploadFiles(formData);
      return res.data.success && res.data.data.toString();
    },
    async uploadFile(file, index) {
      let fileName = await this.upload(file);
      if (fileName) {
        this.form.sliders[index].activeImage = fileName;
      }
      this.$refs["upload" + index][0].clearFiles();
    },
    handleScopeTime(item, index) {
      this.currIndex = index;
      this.visible = true;
      this.ranger = { ...item.bounds };
    },
    setTime(bounds) {
      this.form.sliders[this.currIndex].bounds = bounds;
    },
    setContent(content) {
      this.form.floatContents = content;
    },
    addContent() {
      this.contentVisible = true;
      this.content = this.$utils.deepClone(this.form.floatContents);
    },
    deleteItem(i) {
      this.$confirm("是否确认删除滑动条?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.form.sliders.splice(i, 1);
        })
        .catch(() => {});
    },
    addItem() {
      this.form.sliders.push({
        activeImage: "",
        name: "",
        description: "",
        hint: "",
        unit: "",
        defaultValue: undefined,
        bounds: {},
        propertyId: "",
      });
    },
    move(i, type) {
      let list = this.$utils.handleMoveArr(this.form.sliders, type, i);
      this.$set(this.form, "sliders", list);
    },
    handleSubmit() {
      this.form.sliders.forEach((item) => {
        item.bounds = JSON.stringify(item.bounds);
      });
      return {
        slideWindow: {
          sliderList: this.form.sliders,
        },
        floatContents: this.form.floatContents,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.slider-item__title {
  width: 110px;
  text-align: right;
  color: red;
  margin-bottom: 16px;
}
.basic-form-item {
  .uploadicon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #666;
    font-size: 12px;
    margin-right: 8px;
    border: 1px dashed #d9d9d9;
    width: 28px;
    height: 28px;
    .icon-container {
      width: 28px;
      height: 28px;
      line-height: 28px;
    }
    .img-container {
      width: 28px;
      height: 28px;
      font-size: 0;
      display: inline-block;
      vertical-align: -10px;
      line-height: 0;
    }
  }
  .el-input {
    width: 150px;
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
.initvalue-form-item {
  /deep/.el-form-item__content {
    display: flex;
  }
}
.slider-item__header {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}
</style>
